import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useHistory } from 'react-router-dom';

import { GET_SYSTEMSEARCH } from '../util/schema';
import useLocalStorage from '../util/useLocalStorage';
import SearchIcon from '../icons/SearchIcon.jsx';

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '200%',
  },
  searchBox: {
    '& button': {
      '& svg': {
        color: 'lightgray !important',
      },
    },
  },
  searchIcon: {
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: '90ch',
    },
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
}));

const Search = (isMobile) => {
  const [recentSearches, setRecentSearches] = useLocalStorage('recentSearches', []);
  const addToRecentSearches = (selected) => {
    const updatedSearches = recentSearches;
    if (updatedSearches.filter((e) => e.id === selected.id).length === 0) {
      const mutableSelected = { ...selected };
      mutableSelected.type = `Recent ${mutableSelected.type}`;
      updatedSearches.push(mutableSelected);
    }
    if (updatedSearches.length > 5) {
      updatedSearches.shift();
    }
    setRecentSearches(updatedSearches);
  };
  const classes = useStyles(isMobile);
  const theme = useTheme();
  const [value, setValue] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(recentSearches);
  const [typing, setTyping] = useState(false);
  const history = useHistory();
  const [autoCompletePopupIcon, setAutoCompletePopupIcon] = useState(false);

  const isLargeScreen = useMediaQuery((mqTheme) => mqTheme.breakpoints.up('sm'));
  const arry = [];

  const queryCompleted = (results) => {
    if (
      results.systemSearch &&
      results.systemSearch.cardholders &&
      results.systemSearch.cardholders.edges &&
      results.systemSearch.cardholders.totalCount > 0
    ) {
      results.systemSearch.cardholders.edges.map((cardholder) => [
        arry.push({
          option: `${cardholder.firstName} ${cardholder.lastName}`,
          id: cardholder.id,
          type: 'Cardholders',
        }),
      ]);
      setOptions(arry);
    }
  };

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const [getResults, { data, loading, error }] = useLazyQuery(GET_SYSTEMSEARCH, {
    variables: { searchField: inputValue },
    onCompleted: queryCompleted,
  });
  const handleInputValue = (event, newInputValue) => {
    setInputValue(newInputValue);
    setValue(newInputValue);
    if (inputValue !== null) {
      setTyping(true);
      if (inputValue.length >= 2) {
        getResults();
      } else {
        setOptions(recentSearches);
      }
    }
  };
  const handleOnOpen = (event) => {
    setAutoCompletePopupIcon(true);
  };
  const handleChange = (event, newValue) => {
    let edit;
    if (newValue !== null) {
      edit = newValue.id;
    }

    setValue(newValue);

    if (edit) {
      addToRecentSearches(newValue);
      history.push(`/cardholders/${edit}`);
      setTyping(false);
      setOptions([...recentSearches]);
      setInputValue('');
      setValue('');
    }
  };

  const handleKeyUp = (event) => {
    if (inputValue.length < 3) {
      setTyping(false);
      setOptions(recentSearches);
    }
  };
  const handleClose = () => {
    setValue('');
    setAutoCompletePopupIcon(false);
    setOptions(recentSearches);
  };
  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon style={{ fill: theme.palette.neutral.main }} />
      </div>
      <div>
        <Autocomplete
          fullWidth
          id="global-search"
          className="searchBox"
          //* Free solo and no options text Bug atm */
          // freeSolo
          groupBy={(option) => option.type}
          options={options}
          noOptionsText="No Records Found..."
          getOptionLabel={
            typing
              ? (option) => (option.option ? option.option : option)
              : (option) => (option.option ? option.option : '')
          }
          onChange={handleChange}
          onClose={handleClose}
          value={value}
          forcePopupIcon={autoCompletePopupIcon}
          onOpen={handleOnOpen}
          closeIcon={<CloseIcon fontSize="small" style={{ fill: theme.palette.neutral.main }} />}
          popupIcon={<ArrowDropDownIcon style={{ fill: theme.palette.neutral.main }} />}
          inputValue={inputValue}
          onInputChange={handleInputValue}
          onKeyUpCapture={handleKeyUp}
          getOptionSelected={(option, value) => {
            return option.option.toLowerCase().includes(value.toLowerCase());
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              className={classes.inputInput}
              InputProps={{ ...params.InputProps, disableUnderline: true }}
              placeholder={
                isLargeScreen
                  ? 'Search for Cardholder information, System information, and Settings.'
                  : 'Tap to Search'
              }
              onKeyUpCapture={handleKeyUp}
            />
          )}
        />
      </div>
    </div>
  );
};

export default Search;
